export const NO_VALUE_SELLER_DISCOUNT = {
    discountValue: 0,
    sellerInfo: {
        cpf: "",
        email: "",
        id: 0,
        name: "",
        sellerCode: null,
        numberPhone: "",
        pluginspaceId: 0,
        image: "",
    }
}
